class Counter {
  constructor({
    threshold = 0.5,
    sectionSelector = ".section",
    makeBlocks = false,
    repeat = false,
    locales = "en-GB",
  } = {}) {
    this.makeBlocks = makeBlocks;
    this.locales = locales;
    let observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const targetElement = entry.target;
            const counterItems = targetElement.querySelectorAll(
              "[data-counter-item]"
            );
            if (counterItems.length) {
              this.init(counterItems);
            }

            if (!repeat) {
              observer.unobserve(targetElement);
            }
          }
        });
      },
      { threshold }
    );

    let sections = document.querySelectorAll(sectionSelector);
    if (sections.length) {
      sections.forEach((section) => observer.observe(section));
    }
  }

  init(items = null) {
    let digitItems = items || document.querySelectorAll("[data-counter-item]");

    if (digitItems) {
      digitItems.forEach((item) => {
        const matches_array = item.innerHTML.match(/([^\d]*)([\d]*)([^\d]*)/);
        this.animate(
          item,
          +matches_array[2],
          matches_array[1],
          matches_array[3]
        );
      });
    }
  }

  animate(item, value, prefix, suffix) {
    let startTime = null;
    const duration = parseInt(item.dataset.counterItem) || 1000;
    const finishValue = value;
    const startPosition = 0;

    const step = (timeStamp) => {
      if (!startTime) {
        startTime = timeStamp;
      }

      const progress = Math.min((timeStamp - startTime) / duration, 1);
      if (this.makeBlocks) {
        item.innerHTML = `<span>${prefix}</span>${new Intl.NumberFormat(
          this.locales,
          {
            style: "decimal",
          }
        ).format(
          Math.floor(progress * (startPosition + finishValue))
        )}<span>${suffix}</span>`;
      } else {
        item.innerHTML = `${prefix}${new Intl.NumberFormat(this.locales, {
          style: "decimal",
        }).format(
          Math.floor(progress * (startPosition + finishValue))
        )}${suffix}`;
      }

      if (progress < 1) {
        window.requestAnimationFrame(step);
      }
    };

    window.requestAnimationFrame(step);
  }
}

// Use the Counter class
// window.addEventListener("load", () => {
//   new Counter({
//     sectionSelector: ".counter-section",
//     makeBlocks: "{{ section.settings.make_blocks }}",
//     repeat: "{{ section.settings.repeat }}",
//   });
// });
